module.exports = __webpack_public_path__ + "static/img/advantage2.ced5e4d.webp";


//////////////////
// WEBPACK FOOTER
// ./static/images2/advantage2.webp
// module id = mR3V
// module chunks = 2